import React from 'react';
import { motion } from 'framer-motion';
import { FacebookIcon, InstagramIcon, StarIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="relative bg-[#0A1628] overflow-hidden" data-id="element-144">
      {/* Top wave */}
      <div className="wave-top" data-id="element-145">
        <svg viewBox="0 0 1200 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" data-id="element-146">
          <path d="M0,30 C300,60 900,0 1200,30 L1200,0 L0,0 Z" fill="#f9fafb" data-id="element-147" />
        </svg>
      </div>

      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-148">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 rounded-full" style={{
        background: 'radial-gradient(circle, rgba(11,122,196,0.12) 0%, transparent 70%)'
      }} data-id="element-149" />
        <div className="absolute top-1/2 right-1/4 w-64 h-64 rounded-full" style={{
        background: 'radial-gradient(circle, rgba(122,201,67,0.08) 0%, transparent 70%)'
      }} data-id="element-150" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-8 relative z-10" data-id="element-151">
        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-152">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-153">
            <div className="flex items-center gap-3 mb-6" data-id="element-154">
              <img src="https://cdn.magicpatterns.com/uploads/rXf2f64rQkMtLZPBVphvGA/ChatGPT_Image_Mar_16,_2026,_10_01_47_AM.png" alt="NJ Four Seasons Logo" className="w-14 h-14 object-contain flex-shrink-0 drop-shadow-[0_2px_10px_rgba(11,122,196,0.5)]" data-id="element-155" />
              <div data-id="element-156">
                <span className="text-white font-black text-xl tracking-tight block" data-id="element-157">
                  NJ Four Seasons
                </span>
                <span className="text-gray-500 text-xs uppercase tracking-widest" data-id="element-158">
                  Gutter Cleaning
                </span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-159">
              Protecting homes across New Jersey with premium gutter cleaning,
              repair, and installation services since 2014.
            </p>

            {/* Rating */}
            <div className="flex items-center gap-2 mb-6" data-id="element-160">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#FFD400] fill-current" data-id="element-161" />)}
              <span className="text-gray-300 text-sm font-bold ml-1" data-id="element-162">4.8</span>
              <span className="text-gray-500 text-sm" data-id="element-163">(56 reviews)</span>
            </div>

            <div className="flex gap-3" data-id="element-164">
              {[FacebookIcon, InstagramIcon].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 hover:-translate-y-0.5" style={{
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(255,255,255,0.1)'
            }} data-id="element-165">
                  <Icon className="w-4 h-4" data-id="element-166" />
                </a>)}
            </div>
          </div>

          {/* Services */}
          <div data-id="element-167">
            <h4 className="text-white font-black text-base mb-6 uppercase tracking-wider" data-id="element-168">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-169">
              {['Gutter Cleaning', 'Gutter Repair', 'Gutter Installation', 'Gutter Guards', 'Underground Drains', 'Power Washing'].map(item => <li key={item} data-id="element-170">
                  <a href="#services" className="text-gray-400 hover:text-[#0B7AC4] transition-colors text-sm font-medium flex items-center gap-2 group" data-id="element-171">
                    <span className="w-1 h-1 rounded-full bg-[#0B7AC4] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-172" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-173">
            <h4 className="text-white font-black text-base mb-6 uppercase tracking-wider" data-id="element-174">
              Service Areas
            </h4>
            <ul className="space-y-3" data-id="element-175">
              {['Paterson, NJ', 'Passaic County', 'Bergen County', 'Essex County', 'Clifton & Wayne', 'Hackensack & Paramus'].map(item => <li key={item} data-id="element-176">
                  <a href="#service-areas" className="text-gray-400 hover:text-[#0B7AC4] transition-colors text-sm font-medium flex items-center gap-2 group" data-id="element-177">
                    <span className="w-1 h-1 rounded-full bg-[#7AC943] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-178" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-179">
            <h4 className="text-white font-black text-base mb-6 uppercase tracking-wider" data-id="element-180">
              Contact
            </h4>
            <div className="space-y-5" data-id="element-181">
              <a href="tel:+18554711600" className="flex items-center gap-3 group" data-id="element-182">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors" style={{
                background: 'rgba(255,212,0,0.12)',
                border: '1px solid rgba(255,212,0,0.3)'
              }} data-id="element-183">
                  <PhoneIcon className="w-4 h-4 text-[#FFD400]" data-id="element-184" />
                </div>
                <div data-id="element-185">
                  <span className="text-gray-300 group-hover:text-[#FFD400] transition-colors font-semibold text-sm" data-id="element-186">
                    (855) 471-1600
                  </span>
                  <span className="block text-gray-500 text-[10px] mt-0.5" data-id="element-187">
                    Main Line
                  </span>
                </div>
              </a>
              <a href="tel:+18624072386" className="flex items-center gap-3 group" data-id="element-188">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors" style={{
                background: 'rgba(11,122,196,0.12)',
                border: '1px solid rgba(11,122,196,0.25)'
              }} data-id="element-189">
                  <PhoneIcon className="w-4 h-4 text-[#0B7AC4]" data-id="element-190" />
                </div>
                <div data-id="element-191">
                  <span className="text-gray-400 group-hover:text-[#0B7AC4] transition-colors font-medium text-sm" data-id="element-192">
                    (862) 407-2386
                  </span>
                  <span className="block text-gray-500 text-[10px] mt-0.5" data-id="element-193">
                    Office / Admin
                  </span>
                </div>
              </a>
              <div className="flex items-start gap-3" data-id="element-194">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{
                background: 'rgba(11,122,196,0.12)',
                border: '1px solid rgba(11,122,196,0.3)'
              }} data-id="element-195">
                  <MapPinIcon className="w-4 h-4 text-[#0B7AC4]" data-id="element-196" />
                </div>
                <span className="text-gray-400 text-sm leading-relaxed" data-id="element-197">
                  988 E 19th St 2nd Floor
                  <br data-id="element-198" />
                  Paterson, NJ 07501
                </span>
              </div>
              <div className="pt-2" data-id="element-199">
                <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-2" data-id="element-200">
                  Hours
                </p>
                <p className="text-gray-400 text-sm" data-id="element-201">Mon–Sat: 7AM – 7PM</p>
                <p className="text-gray-400 text-sm" data-id="element-202">Sun: 8AM – 5PM</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4" style={{
        borderTop: '1px solid rgba(255,255,255,0.07)'
      }} data-id="element-203">
          <p className="text-gray-600 text-sm text-center md:text-left" data-id="element-204">
            © {new Date().getFullYear()} NJ Four Seasons Gutter Cleaning ·
            NJHICRA #13VH08498200 · Licensed & Insured
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-600" data-id="element-205">
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-206">
              Privacy Policy
            </a>
            <span data-id="element-207">·</span>
            <a href="#" className="hover:text-gray-400 transition-colors" data-id="element-208">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}